module.exports = __webpack_public_path__ + "img/DCIBg03.5f276345.png";